"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var upload_image_html_1 = __importDefault(require("./upload-image.html"));
require("./upload-image.less");
(function (module) {
    'use strict';
    module.factory('prImageUploadModal', [
        '$rootScope',
        'qstrap.modal',
        '$filter',
        function ($rootScope, modal, $filter) {
            var translate = $filter('translate');
            return {
                show: function (libraryId, folders, callback) {
                    var scope = $rootScope.$new();
                    scope.folderOptions = folders;
                    scope.libraryId = libraryId;
                    scope.setImage = function (imageId) {
                        if (_.isFunction(callback)) {
                            callback(imageId);
                        }
                    };
                    return modal({
                        show: true,
                        scope: scope,
                        className: 'pr-graphic-library-image-upload',
                        title: translate('UPLOAD_IMAGE'),
                        contentTemplate: upload_image_html_1.default,
                        controller: 'UploadImageController',
                        buttons: [
                            '<button class="btn btn-success" ng-disabled="ctrl.invalid()" ' +
                                'ng-click="ctrl.uploadImageToLibrary();" translate>SAVE</button>',
                            '<button class="btn btn-hover" ng-click="close()" translate>CLOSE</button>'
                        ],
                    });
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
